<template>
  <!-- <div class="gridMainLayout">
    <div class="collection-title">
      <h2>{{$t('Continue watching')}}</h2>
    </div>
    <div v-if="dataFetched"
      :class="[
        localDisplayLang === 'ara'
          ? 'mainContainerContinueWatchAra'
          : 'mainContainerContinueWatch',
      ]"
      :dir="localDisplayLang === 'ara' ? 'rtl' : 'ltr'"
      class="gridContainer"
    >
      <div
        class="continueWatchCardContainer gridCardWrapper" 
        v-for="(item, index) in continueData"
        :key="index"
        @click="playContent(item, index)"
      >
        <div class="continueWatchCard gridCardLayout">
          <div class="gridPosterLayout">
            <ImageTemplate :content="item" :borderRadius="'4px'" :displayType="'PORTRAIT'"></ImageTemplate>
            <img
              src="@/assets/icons/remove-watchlist.svg"
              class="removeFromWatch"
              @click.stop="removeFromWatchlist(item)"
              alt
            />          
            <div class="play-img">
              <img src="@/assets/icons/Ic_Play1.svg" alt="" />            
            </div>
            <div
              v-if="dataFetched"
              class="grayLine"
              :dir="localDisplayLang === 'ara' ? 'rtl' : 'ltr'"
            ></div>
            <div
              class="progressPercent"
              :style="{ width: calculatePercentage(item) + '%' }"
              :dir="localDisplayLang === 'ara' ? 'rtl' : 'ltr'"
            ></div>
          </div>
          <div class="gridContentLayout">
            <div class="gridContentTitle">
              <p class="gridTitle" :title="item.title">{{ item.title }}</p>
            </div>
            <div class="gridContentDetails">
              <div class="main-info">
                <div class="ua-rating" v-if="item.advisory">
                  <p>{{ item.advisory }}</p>
                </div>
                <div class="publish-year" v-if="item.productionyear">
                  <p>{{ item.productionyear }}</p>
                </div>
                <div class="duration" v-if="item.duration">
                  <p>{{ calcTimeFormat(item.duration) }}</p>
                </div>
                <div class="pgrating" v-if="item.pgrating">
                  <p>{{ item.pgrating }}</p>
                </div>
              </div>
              <div class="main-genre">
                <div class="sub-genre1" v-if="item.category">
                  <p>{{ $t(item.category) }}</p>
                </div>
                <div
                  class="sub-genre2"
                  v-if="item.genre"
                  :class="{ 'with-bullet': item.category }"
                >
                  <p>{{ $t(item.genre) }}</p>
                </div>
                <div
                  class="sub-genre3"
                  v-if="item.contentlanguage && item.contentlanguage.length > 0"
                  :class="{ 'with-bullet': item.category || item.genre }"
                >
                  <p>{{ $t(item.contentlanguage) }}</p>
                </div>
              </div>
            </div>
            <p class="gridDescription" v-if="item.shortdescription || item.longdescription">
              {{ getDescription(item, 150) }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!dataFetched">
      <GridLayoutPlaceholder></GridLayoutPlaceholder>
    </div>
  </div> -->
  <div class="collection" id="continueWatchSeeAll">
    <div class="collection-title">
      <h2>{{$t('Continue watching')}}</h2>
    </div>
    <Grid :contents="continueData" :displayType="'LANDSCAPE'"
      :isScrollable="isScrollable" @loadMore="loadMoreContents()" 
       :showRemove="true" @remove="checkWatchlistContent" v-if="dataFetched"></Grid>
    <div v-else>
      <GridLayoutPlaceholder :displayType="'LANDSCAPE'"></GridLayoutPlaceholder>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/eventBus";
import { getDatabase, ref, get } from "firebase/database";
import Utility from "@/mixins/Utility.js";
import FirebaseActions from "@/mixins/FirebaseActions";
import PlaybackUtilities from "@/mixins/playbackUtilities.js";
import { mapActions, mapGetters } from "vuex";
import Redirection from "@/mixins/redirection.js";
import { store } from "@/store/store";

export default {
  props: {
    playerInstance: {
      type: Object,
    },
  },
  data() {
    return {
      movieObjs: [],
      episodeObjs: [],
      continueWatchFirebaseData: null,
      newEpisodeObj: null,
      segEpisodeArr: null,
      continueWatchContent: [],
      continueWatchDataTemp: null,
      localDisplayLang: null,
      page: 1,
      pageMovie: 1,
      seriesPage: 1,
      moviesPage: 1,
      isMpegRequired: false,
      finalData: [],
      pageSize: 15,
      continueData: null,
      finalMovieData: [],
      dataFetched: false,
      episodeList: [],
      totalEpisodeCount: 0,
      isDirectPlay: true,
      availabilities: [],
      filteredAvailabilities: [],
      gotPosterItem: null,
      placeholder_port: require('@/assets/placeholder-port.svg'),
      placeholder_lands: require('@/assets/placeholder-lands.svg'),
      allContentObjIds: []
    };
  },

  created() {
    this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
    this.localDisplayLang = this.localDisplayLang == 'eng' ? 'en' : this.localDisplayLang;

    
    // this.continueWatchFirebaseData = this.$route.params.continueWatchData;
    if (this.availabilityList !== undefined) {
      this.availabilities = this.availabilityList;
    }

    //assigning subscription list response.
    if (this.subscriptionList !== undefined) {
      this.subscriptions = this.subscriptionList;
    }
  },
  components: {
    ImageTemplate: () => import(/* webpackChunkName: "imageTemplate" */ "@/components/Templates/Image.vue"),
    GridLayoutPlaceholder: () => import(/* webpackChunkName: "gridplaceholder" */ "@/components/placeholders/GridLayoutPlaceholder.vue"),
    Grid: () => import(/* webpackChunkName: "Grid" */ "@/components/Templates/GridLayout.vue"),
  },
  watch: {
    subscriptionList(val) {
      if (val) {
        this.subscriptions = val;
        // this.getAvailability(this.content);
      }
    },
    availabilityList(val) {
      if (val) {
        this.availabilities = val;
        // this.getAvailability(this.content);
      }
    },
  },
  methods: {
    ...mapActions(["listContent"]),
    checkEpisodeContinueWatch() {
      this.continueWatchContent = [];
      this.continueWatchData = [];
      this.detailPlaylist = [];
      this.finalPlaylist = [];
      this.completeEpisodeListing = [];
      this.continueData = [];

      let path = "",
        response = null,
        episodeObjs = null,
        newEpisodeObj = null,
        segEpisodeArr = null,
        movieObjs = null;

      if (this.subscriberid || this.profileid) {
        path = `/subscriber/${this.subscriberid}/${this.profileid}/content/`;

        const db = getDatabase();
        const contentRef = ref(db, path);

        get(contentRef)
          .then((snapshot) => {
            if (!snapshot.exists()) return;
            response = this.collectionsToArray(snapshot.val());

            // Filter movies that are in-progress and have watched duration
            movieObjs = response.filter((element) => {
              return (
                element.category === "MOVIE" &&
                element.status === "INPROGRESS"
              );
            });

            // Filter series (those containing episodes)
            episodeObjs = response.filter((element) => element.episodes);

            // Convert to array of series with episodes
            newEpisodeObj = [...this.collectionsToArray(episodeObjs)];

            // For each series, pick the most recently watched episode
            newEpisodeObj.forEach((element) => {
              segEpisodeArr = this.collectionsToArray(element.episodes);

              segEpisodeArr.forEach((el) => {
                el.title = element.title;
              });

              // Sort by updated timestamp (most recent first)
              segEpisodeArr = segEpisodeArr.sort((a, b) => b.updatedat - a.updatedat);

              // Push the latest watched episode
              this.continueWatchContent.push(segEpisodeArr[0]);
            });

            // Merge movies and episodes
            this.continueWatchDataTemp = [
              ...this.continueWatchContent,
              ...movieObjs,
            ];

            // Sort combined list by updated timestamp
            this.continueWatchDataTemp = this.continueWatchDataTemp.sort(
              (a, b) => b.updatedat - a.updatedat
            );
            this.continueWatchDataTemp = this.continueWatchDataTemp.filter((element) => element.status === "INPROGRESS");
            console.log("checkEpisodeContinueWatch", this.continueWatchDataTemp);
            this.checkLanguage();
          })
          .catch((error) => {
            console.error("Error fetching continue watch data:", error);
          });
      }
    },
    scrollTop() {
      window.scrollTo(0, 0);
    },
    calculatePercentage(item) {
      // console.log('PERCENTAGE IS ',item)
      return (item.watchedduration / item.duration) * 100;
    },
    checkWatchlistContent(data) {
      this.removeFromContinueWatch(data).then(()=>{
        this.continueData = this.continueData.filter((item, i) => {
          return data.objectid!== item.objectid;
        });
      // this.checkEpisodeContinueWatch();
      });
      // this.dataFetched = false;
    },
    checkLanguage() {
      let allObjIds = [];
      this.continueWatchDataTemp.forEach((element) => {
        if(!(element.isAdultContent)) {
          allObjIds.push(`"${element.objectid}"`);
        }
      });
      this.callPromises(allObjIds);
    },
    async playContent(content) {
      if (this.isDirectPlay && this.subscriberid) {
        if(content && content.playbacktype == "EXTERNALURLBASEDPLAYBACK") {
          let episodeIndex = 0;
          let episodeList = [content];
          let totalCount = episodeList.length;
          let isPlaybackAllowed = this.checkAvailabilityAllowsPlayback(episodeList[episodeIndex]);        
          if (isPlaybackAllowed) {
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            let uriData = null;
            const urlencoded = new URLSearchParams();
            if(isSafari) {
                uriData = await this.parseHlsManifest(episodeList[episodeIndex].streamUrl);
                if(uriData) {
                    urlencoded.append("keyid", uriData[0]);
                    urlencoded.append("keyiv", uriData[1]);
                }
            }
            urlencoded.append("contentid", episodeList[episodeIndex].channelid || episodeList[episodeIndex].objectid);
            urlencoded.append("ios", isSafari ? true : false);
            urlencoded.append("seclevel", "SW");
            let drmPromise = store.dispatch("actGetDRMToken", urlencoded);
            Promise.all([drmPromise])
            .then(async ([drmRes]) => {
                let contentData = episodeList[episodeIndex];
                contentData['drmTokenResp'] = drmRes.data;
                eventBus.$emit("live-player-active", contentData);
            })
            .catch((err) => {
                console.log("err", err);
            });
            // eventBus.$emit('live-player-active', content);
            // this.showPlayer();
            // this.actBuyDRMToPlayer(episodeIndex, episodeList, totalCount, true);
          } else if(!isPlaybackAllowed && this.subscriberid) {
            this.redirectToPlans();
          }
          return
        }
      //   this.showPlayer();
      //   if(content && content.playbacktype == "EXTERNALURLBASEDPLAYBACK") {
      //   let episodeIndex = 0;
      //   let episodeList = [content];
      //   let totalCount = episodeList.length;
      //   this.actBuyDRMToPlayer(episodeIndex, episodeList, totalCount, true);
      //   return
      // } else {
      //   if (content.category == "MOVIE") {
      //     let episodeIndex = 0;
      //     this.episodeList = [content];
      //     this.totalEpisodeCount = 1;

      //     this.loadChosenIndexContent(
      //       episodeIndex,
      //       this.episodeList,
      //       this.totalEpisodeCount,
      //       true
      //     );
      //   } else {
      //     let returnCode = this.fetchEpisodeRecursively(
      //       this.fetchEpisodes,
      //       content,
      //       this.checkEpisodeInList,
      //       false
      //     );

      //     returnCode
      //       .then(() => {
      //         let episodeIndex = this.getEpisodeIndexInList(
      //           content.objectid,
      //           this.episodeList
      //         );

      //         this.loadChosenIndexContent(
      //           episodeIndex,
      //           this.episodeList,
      //           this.totalEpisodeCount,
      //           true
      //         );
      //       })
      //       .catch((error) => {
      //         console.log("Error encountered : ", error);
      //       });
      //   }
      // }
      } else if (!this.subscriberid) {
        //open lookup popup.
        let localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
        localDisplayLang = localDisplayLang == 'eng' ? 'en' : localDisplayLang;
        this.redirectToLogin(localDisplayLang);
        // let payload = {
        //   state: true,
        //   formType: "lookup",
        // };
        // eventBus.$emit("authPopup", payload);
      }
    },
    showPlayer() {
      // this.playerInstance.blowUpPlayer();
      this.playerInstance.registerEvent(
        "currentcontentended",
        this.loadNextContentData
      );
      this.playerInstance.registerEvent(
        "loadchosencontent",
        this.loadChosenContentData
      );
      this.playerInstance.registerEvent(
        "loadmorecontent",
        this.loadMoreContentData
      );

      this.playbackInitiated = true;
      eventBus.$emit("player-visibility", true);
    },
    callPromises(allObjIds) {
      let allPromise;
      let idList = allObjIds.slice(0, 100);
      if(allObjIds && allObjIds.length > 0) {
        const payload = {
          contentlist: "[" + allObjIds + "]",
          displaylanguage: this.localDisplayLang,
          page: this.moviesPage,
          pagesize: '100',
        };
        allPromise = new Promise((resolve, reject) => {
          this.fetchAllDataRecursively(payload).then((data) => {
           setTimeout(()=>{
              resolve(data);
           },2000)
          });
        });
      }

      //RESOLVE BOTH PROMISES
      Promise.all([allPromise]).then(([allData]) => {
        // console.log("finalData_1", seriesData, moviesData);
        this.continueWatchData = [...(allData?.length ? allData : [])];
        if (this.continueWatchData && this.continueWatchData.length > 0) {
          this.continueWatchDataTemp.map((fireBaseItem, fireBaseItemIndex) => {
            this.continueWatchData.map((apiItem, apiItemIndex) => {
              if (apiItem.objectid === fireBaseItem.objectid) {
                let duration = fireBaseItem.duration;
                let watched = fireBaseItem.watchedduration;
                let progress = (watched / duration) * 100;
                this.continueWatchData[apiItemIndex] = {
                  ...apiItem,
                  status : fireBaseItem.status,
                  updatedat: fireBaseItem.updatedat,
                  watchedduration: fireBaseItem.watchedduration,
                  progress: (progress > 0 && progress < 100) ? progress : null
                };
              }
            });
          });
         this.continueData = this.continueWatchData.sort((a, b) => {
            return b.updatedat - a.updatedat;
          });
        }
        this.continueData = this.continueData.filter((item) => {
          return item.status === "INPROGRESS" && item?.contentprovider?.toLowerCase() !== "hotgo";
        });
        this.dataFetched = true;
      });
    },
    fetchAllDataRecursively(payload) {
      return new Promise((resolve, reject) => {
        this.listContent(payload).then((data) => {
          if(data.data.data) {
            this.finalData = [...this.finalData, ...data.data.data];
          }
          console.log(">>>finalData", this.finalData)
          if (this.finalData.length < data.data.totalcount) {
            let newPayload = {
              contentlist: payload.contentlist,
              displaylanguage: payload.displaylanguage,
              page: 1,
              pagesize: '100',
            };

            // this.fetchAllDataRecursively(newPayload);
          }
          // setTimeout(() => {
          //   resolve(this.finalData);
          // }, 2000);
          resolve(this.finalData);
        });
      });
    },
    getPoster(content) {
      if (content.poster && content.poster.length) {
        let index = content.poster.findIndex((element) => {
            return element.postertype === "LANDSCAPE";
        });
        if (index > -1) {
            content.poster[index].filelist.filter((el) => {
              if (el.quality === "THUMBNAIL") {
                this.gotPosterItem = el.filename;
              } else {
                if (el.quality === "LOW") {
                  this.gotPosterItem = el.filename;
                } else if (el.quality === "SD") {
                  this.gotPosterItem = el.filename;
                } else if (el.quality === "HD") {
                  this.gotPosterItem = el.filename;
                }
              }
            });
        } else {
          this.gotPosterItem = content.poster[0].filelist && content.poster[0].filelist[0] ? content.poster[0].filelist[0].filename : ''
        }
      } else {
        if (content.poster && content.poster.landscape) {
          this.gotPosterItem = content.poster.landscape;
        } else {
          this.gotPosterItem = this.placeholder_lands;
        }
        
      }      
      return this.gotPosterItem;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollTop();
      this.checkEpisodeContinueWatch();
    })
  },
  computed: {
    ...mapGetters([
      "subscriberid",
      "availabilityList",
      "subscriptionList",
      "purchaseList",
      "profileid",
      "getRtl",
      "getContinueWatchData",
    ]),
  },
  mixins: [Utility, PlaybackUtilities, Redirection, FirebaseActions],
};
</script>

<style lang="scss" scoped>
@import "@/sass/_variables.scss";
@import "@/sass/_components.scss";
@import "@/components/Templates/Grid.scss";

.gridMainLayout {
    // width: clamp(2rem, 100%, 95%);
    // margin: 4rem auto auto auto; 
    // display: flex;
    // flex-direction: column;
    // gap: 0.5rem;
  .collection-title {
    padding: 0.5rem 2rem;
    text-align: center;
    text-transform: uppercase;
    opacity: 0.7;
  }
}

.play-img {
  display: flex;
  justify-content: center;
  align-items: center;
  img{
    height: 36px !important;
    width: 36px !important;
    background: none !important;
  }
}

.progressPercent {
  position: absolute;
  left: 0%;
  bottom: 1%;
  height: 3%;
  background:  $primary-btn-color;
  width: 90%;
  border-radius: 8px;
  margin: 0 0.2rem;
  z-index: 777;
}

.collection {
  width: clamp(2rem, 100%, 95%);
  margin: 4rem auto auto auto;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  .collection-title {
    padding: 0.5rem 2rem;
    text-align: center;
    text-transform: uppercase;
    opacity: 0.7;
  }

  .gridMainLayout {
    padding-top: 0 !important;
  }
}

@media screen and (max-width:1023px) {
  .collection {
    margin-top: 4rem;
  }
}
</style>
